import {Grid, Typography, Box, Card} from '@mui/material'
import moment from 'moment'
import React from 'react'

import {DeliveryTime, SlotSiloConfig} from '../../../../../OrderIntake/declarations/types'
import {Slot, TimeSlotSectionProps} from '../types'
import {trackEvent} from '../../../../../common/analytics'

export const TimeSlotSelection = ({
  title,
  slots,
  setSelectedDeliveryTimeSlot,
  selectedDeliveryTimeSlot,
  onChange,
  setSelectedSlotSiloConfig,
  setSelectedSlot,
  externalReference
}: TimeSlotSectionProps) => {
  const handleSelect = (data: Slot) => {
    // set selected delivery time, slot and silo config
    const deliveryTime: DeliveryTime = {
      earliest: data.slotConfig.slotStart,
      latest: data.slotConfig.slotEnd
    }
    const slotConfig: SlotSiloConfig = {
      loadingStation: data.loadingStation,
      siloNumber: data.siloNumber,
      externalReference,
      plantId: data.plantId,
      materialNumber: data.materialNumber
    }
    if (setSelectedDeliveryTimeSlot) {
      setSelectedDeliveryTimeSlot(deliveryTime)
      setSelectedSlotSiloConfig(slotConfig)
      setSelectedSlot(data)
      onChange(deliveryTime)
    }

    // track time slot selection event
    trackEvent('hubBulkCementOrderIntakeTimeSlotSelected', {
      slotStart: data.slotConfig.slotStart,
      slotEnd: data.slotConfig.slotEnd,
      loadingStation: data.loadingStation,
      siloNumber: data.siloNumber,
      externalReference,
      materialNumber: data.materialNumber,
      slotDurationMinutes: data.slotDurationMinutes,
      plantId: data.plantId,
      date: data.date,
      slotStatus: data.slotStatus.statusName
    })
  }

  return (
    <>
      <Box>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '16px',
            color: '#54708C',
            textTransform: 'capitalize'
          }}
        >
          {title}
        </Typography>
      </Box>
      <Grid container spacing={1}>
        {slots.map((slot, index) => {
          const formattedSlotTime = moment(slot.slotConfig.slotStart, 'HH:mm:ss').format('HH:mm')
          const isSelected = selectedDeliveryTimeSlot?.earliest === slot.slotConfig.slotStart
          return (
            <Grid item xs={12} sm={6} lg={4} key={index}>
              <Card
                onClick={() => handleSelect(slot)}
                sx={{
                  color: isSelected ? '#fff' : '#0a2342',
                  backgroundColor: isSelected ? '#29aaff' : '#fff',
                  minWidth: '84px',
                  maxWidth: '120px',
                  height: '46px',
                  borderRadius: '6px',
                  margin: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  cursor: 'pointer',
                  borderColor: 'grey.300',
                  border: isSelected ? 'none' : '1px solid #e0e0e0',
                  boxShadow: 1,
                  '&:hover': {borderColor: 'primary.main', boxShadow: 1}
                }}
                data-test-id={`time-slot-preference-${formattedSlotTime}${
                  isSelected ? '-selected' : '-available'
                }`}
              >
                <Typography variant="body2" align="center">
                  {formattedSlotTime}
                </Typography>
              </Card>
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}
